export default {
  en: {
    "All_files_and_folders": "All files and folders",
    "Dashboard": "Dashboard",
    "Calendar": "Calendar",
    "Tasks": "Tasks",
    "Contacts": "Contacts",
    "Contact List": "Contact List",
    "New Contact": "New Contact",
    "Matters": "Matters",
    "Matter List": "Matter List",
    "New Matter": "New Matter",
    "Notes": "Notes",
    "Notes List": "Notes List",
    "New Note": "New Note",
    "Activities": "Activities",
    "Documents": "Documents",
    "Communications": "Communications",
    "Accounts": "Accounts",
    "Billing": "Billing",
    "Reports": "Reports",
    "Settings": "Settings",
    eCommerce: 'eCommerce',
    Apps: 'Apps',
    Todo: 'Todo',
    Chat: 'Chat',
    Email: 'Email',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
    Shop: 'Shop',
    ItemDetails: 'Item Details',
    Cart: 'Cart',
    WishList: 'Wish List',
    Checkout: 'Checkout',
    UI: 'UI',
    DataList: 'Data List',
    ListView: 'List View',
    ThumbView: 'Thumb View',
    Grid: 'Grid',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Colors',
    Card: 'Card',
    Basic: 'Basic',
    Statistics: 'Statistics',
    Analytics: 'Analytics',
    CardActions: 'Card Actions',
    CardColors: 'Card Colors',
    Table: 'Table',
    agGridTable: 'agGrid Table',
    Components: 'Components',
    Alert: 'Alert',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Button',
    ButtonGroup: 'Button Group',
    Chip: 'Chip',
    Collapse: 'Collapse',
    Dialogs: 'Dialogs',
    Divider: 'Divider',
    DropDown: 'DropDown',
    List: 'List',
    Loading: 'Loading',
    Navbar: 'Navbar',
    Notifications: 'Notifications',
    Pagination: 'Pagination',
    Popup: 'Popup',
    Progress: 'Progress',
    Sidebar: 'Sidebar',
    Slider: 'Slider',
    Tabs: 'Tabs',
    Tooltip: 'Tooltip',
    Upload: 'Upload',
    FormsAndTable: 'Forms & Table',
    FormElements: 'Form Elements',
    Select: 'Select',
    Switch: 'Switch',
    Checkbox: 'Checkbox',
    Radio: 'Radio',
    Input: 'Input',
    NumberInput: 'Number Input',
    Textarea: 'Textarea',
    FormLayouts: 'Form Layouts',
    FormWizard: 'Form Wizard',
    FormValidation: 'Form Validation',
    FormInputGroup: 'Form Input Group',
    Pages: 'Pages',
    Authentication: 'Authentication',
    Login: 'Login',
    Register: 'Register',
    ForgotPassword: 'Forgot Password',
    ResetPassword: 'Reset Password',
    LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
    ComingSoon: 'Coming Soon',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Not Authorized',
    Maintenance: 'Maintenance',
    Profile: 'Profile',
    User: 'User',
    View: 'View',
    Edit: 'Edit',
    UserSettings: 'User Settings',
    Invoice: 'Invoice',
    FAQ: 'FAQ',
    Search: 'Search',
    KnowledgeBase: 'Knowledge Base',
    ChartsAndMaps: 'Charts & Maps',
    Charts: 'Charts',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Map',
    Extensions: 'Extensions',
    QuillEditor: 'Quill Editor',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Datetime Picker',
    AccessControl: 'Access Control',
    I18n: 'I18n',
    Carousel: 'Carousel',
    Clipboard: 'Clipboard',
    ContextMenu: 'Context Menu',
    StarRatings: 'Star Ratings',
    Autocomplete: 'Autocomplete',
    Tree: 'Tree',
    // "Import/Export": 'Import/Export',
    Import: 'Import',
    Export: 'Export',
    ExportSelected: 'Export Selected',
    Others: 'Others',
    MenuLevels: 'Menu Levels',
    MenuLevel2p1: 'Menu Level 2.1',
    MenuLevel2p2: 'Menu Level 2.2',
    MenuLevel3p1: 'Menu Level 3.1',
    MenuLevel3p2: 'Menu Level 3.2',
    DisabledMenu: 'Disabled Menu',
    Support: 'Support',
    Documentation: 'Documentation',
    RaiseSupport: 'Raise Support',
    demoTitle: 'Card Title',
    demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.'
  },
  de: {
    "All_files_and_folders": "wwwewewe",
    Dashboard: 'Instrumententafel',
    eCommerce: 'eCommerce',
    Apps: 'Apps',
    Todo: 'Machen',
    Chat: 'Plaudern',
    Email: 'Email',
    Calendar: 'Kalender',
    FullCalendar: 'Calendrier completVollständiger Kalender',
    SimpleCalendar: 'Einfacher Kalender',
    Shop: 'Geschäft',
    ItemDetails: 'Artikeldetails',
    Cart: 'Wagen',
    WishList: 'Wunschzettel',
    Checkout: 'Auschecken',
    UI: 'UI',
    DataList: 'Datenliste',
    ListView: 'Listenansicht',
    ThumbView: 'Daumenansicht',
    Grid: 'Gitter',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Farben',
    Card: 'Karte',
    Basic: 'Basic',
    Statistics: 'Statistiken',
    Analytics: 'Analytics',
    CardActions: 'Kartenaktionen',
    CardColors: 'Kartenfarben',
    Table: 'Tabelle',
    agGridTable: 'agGrid-Tabelle',
    Components: 'Komponenten',
    Alert: 'Warnen',
    Avatar: 'Benutzerbild',
    Badge: 'Abzeichen',
    Breadcrumb: 'Breadcrumb',
    Button: 'Taste',
    ButtonGroup: 'Schaltflächengruppe',
    Chip: 'Chip',
    Collapse: 'Zusammenbruch',
    Dialogs: 'Dialoge',
    Divider: 'Teiler',
    DropDown: 'Dropdown-Liste',
    List: 'Liste',
    Loading: 'Wird geladen',
    Navbar: 'Navbar',
    Notifications: 'Benachrichtigungen',
    Pagination: 'Seitennummerierung',
    Popup: 'Pop-up',
    Progress: 'Fortschritt',
    Sidebar: 'Seitenleiste',
    Slider: 'Schieberegler',
    Tabs: 'Tabs',
    Tooltip: 'QuickInfo',
    Upload: 'Hochladen',
    FormsAndTable: 'Formulare und Tabelle',
    FormElements: 'Formularelemente',
    Select: 'Wählen',
    Switch: 'Schalter',
    Checkbox: 'Ankreuzfeld',
    Radio: 'Radio',
    Input: 'Eingang',
    NumberInput: 'Nummer eingeben',
    Textarea: 'Textbereich',
    FormLayouts: 'Formularlayouts',
    FormWizard: 'Formzauberer',
    FormValidation: 'Formularvalidierung',
    FormInputGroup: 'Formulareingabegruppe',
    Pages: 'Seiten',
    Authentication: 'Authentifizierung',
    Login: 'Anmeldung',
    Register: 'Registrieren',
    ForgotPassword: 'Passwort vergessen',
    ResetPassword: 'Passwort zurücksetzen',
    LockScreen: 'Bildschirm sperren',
    Miscellaneous: 'Verschiedenes',
    ComingSoon: 'Demnächst',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Nicht berechtigt',
    Maintenance: 'Instandhaltung',
    Profile: 'Profil',
    User: 'Benutzer',
    View: 'Aussicht',
    Edit: 'Bearbeiten',
    UserSettings: 'Benutzereinstellungen',
    Invoice: 'Rechnung',
    FAQ: 'FAQ',
    Search: 'Suche',
    KnowledgeBase: 'Wissensbasis',
    ChartsAndMaps: 'Diagramme und Karten',
    Charts: 'Diagramme',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Karte',
    Extensions: 'Erweiterungen',
    QuillEditor: 'Quill-Editor',
    DragAndDrop: 'Ziehen und loslassen',
    Datepicker: 'Datumsauswahl',
    DatetimePicker: 'Datum / Uhrzeit-Auswahl',
    AccessControl: 'Zugangskontrolle',
    I18n: 'I18n',
    Carousel: 'Karussell',
    Clipboard: 'Zwischenablage',
    ContextMenu: 'Kontextmenü',
    StarRatings: 'Sterne Bewertungen',
    Autocomplete: 'Autovervollständigung',
    Tree: 'Baum',
    // "Import/Export": 'Einführen/Export',
    Import: 'Einführen',
    Export: 'Export',
    ExportSelected: 'Auswahl exportieren',
    Others: 'Andere',
    MenuLevels: 'Menüebenen',
    MenuLevel2p1: 'Menüebene 2.1',
    MenuLevel2p2: 'Menüebene 2.2',
    MenuLevel3p1: 'Menüebene 3.1',
    MenuLevel3p2: 'Menüebene 3.2',
    DisabledMenu: 'Deaktiviertes Menü',
    Support: 'Unterstützung',
    Documentation: 'Dokumentation',
    RaiseSupport: 'Unterstützung erheben',
    demoTitle: 'Kartentitel',
    demoText: 'Kuchen Sesam Schnaps Cupcake Lebkuchen Dänisch Ich liebe Lebkuchen. Apfelkuchen-Torte-Jujuben chupa chups muffin halvah Lutscher. Schokoladenkuchenhaferkuchen Tiramisu-Marzipanzuckerpflaume. Donut süße Kuchen Hafer Kuchen Dragée Obstkuchen Zuckerwatte Zitrone Tropfen.'
  },
  fr: {
    "All_files_and_folders": "wwwewewe",
    Dashboard: 'Tableau de bord',
    eCommerce: 'commerce électronique',
    Apps: 'Applications',
    Todo: 'Faire',
    Chat: 'Bavarder',
    Email: 'Email',
    Calendar: 'Calendrier',
    FullCalendar: 'Calendrier complet',
    SimpleCalendar: 'Calendrier simple',
    Shop: 'Boutique',
    ItemDetails: 'Détails de l\'article',
    Cart: 'Chariot',
    WishList: 'Liste de souhaits',
    Checkout: 'Check-out',
    UI: 'UI',
    DataList: 'Liste de données',
    ListView: 'Voir la liste',
    ThumbView: 'Thumb View',
    Grid: 'la grille',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Couleurs',
    Card: 'Carte',
    Basic: 'De base',
    Statistics: 'Statistiques',
    Analytics: 'Analytique',
    CardActions: 'Actions de carte',
    CardColors: 'Couleurs de la carte',
    Table: 'Table',
    agGridTable: 'tableau agGrid',
    Components: 'Composants',
    Alert: 'Alerte',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Bouton',
    ButtonGroup: 'Groupe de boutons',
    Chip: 'Puce',
    Collapse: 'Effondrer',
    Dialogs: 'Dialogues',
    Divider: 'Diviseur',
    DropDown: 'Menu déroulant',
    List: 'liste',
    Loading: 'Chargement',
    Navbar: 'Barre de navigation',
    Notifications: 'Les notifications',
    Pagination: 'Pagination',
    Popup: 'Apparaitre',
    Progress: 'Le progrès',
    Sidebar: 'Barre latérale',
    Slider: 'Curseur',
    Tabs: 'Onglets',
    Tooltip: 'Info-bulle',
    Upload: 'Télécharger',
    FormsAndTable: 'Formulaires et tableau',
    FormElements: 'Éléments de formulaire',
    Select: 'Sélectionner',
    Switch: 'Commutateur',
    Checkbox: 'Case à cocher',
    Radio: 'Radio',
    Input: 'Contribution',
    NumberInput: 'Nombre d\'entrée',
    Textarea: 'Textarea',
    FormLayouts: 'Dispositions de formulaire',
    FormWizard: 'Assistant de formulaire',
    FormValidation: 'Validation du formulaire',
    FormInputGroup: 'Groupe de saisie de formulaire',
    Pages: 'Pages',
    Authentication: 'Authentification',
    Login: 'S\'identifier',
    Register: 'registre',
    ForgotPassword: 'Mot de passe oublié',
    ResetPassword: 'réinitialiser le mot de passe',
    LockScreen: 'Écran verrouillé',
    Miscellaneous: 'Divers',
    ComingSoon: 'Arrive bientôt',
    Error: 'Erreur',
    404: '404',
    500: '500',
    NotAuthorized: 'Pas autorisé',
    Maintenance: 'Entretien',
    Profile: 'Profil',
    User: 'Utilisateur',
    View: 'Vue',
    Edit: 'Modifier',
    UserSettings: 'Paramètres utilisateur',
    Invoice: 'Facture d\'achat',
    FAQ: 'FAQ',
    Search: 'Chercher',
    KnowledgeBase: 'Base de connaissances',
    ChartsAndMaps: 'Graphiques Et Cartes',
    Charts: 'Graphiques',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Carte',
    Extensions: 'Extensions',
    QuillEditor: 'Éditeur de piquants',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Sélecteur de date',
    DatetimePicker: 'Sélecteur de date / heure',
    AccessControl: 'Contrôle d\'accès',
    I18n: 'I18n',
    Carousel: 'Carrousel',
    Clipboard: 'Presse-papiers',
    ContextMenu: 'Menu contextuel',
    StarRatings: 'Classement par étoiles',
    Autocomplete: 'Terminé automatiquement',
    Tree: 'Arbre',
    // "Import/Export": 'Importation/Exportation',
    Import: 'Importation',
    Export: 'Exportation',
    ExportSelected: 'Exporter sélectionné',
    Others: 'Autre',
    MenuLevels: 'Niveaux de menu',
    MenuLevel2p1: 'Niveau de menu 2.1',
    MenuLevel2p2: 'Niveau de menu 2.2',
    MenuLevel3p1: 'Niveau de menu 3.1',
    MenuLevel3p2: 'Niveau de menu 3.2',
    DisabledMenu: 'Menu désactivé',
    Support: 'Soutien',
    Documentation: 'Documentation',
    RaiseSupport: 'Augmenter le soutien',
    demoTitle: 'Titre de la carte',
    demoText: 'Le gâteau au sésame s\'enclenche au petit pain au pain d\'épices danois J\'adore le pain d\'épices. Tarte aux pommes et jujubes chupa chups muffin halvah sucette. Tiramisu gâteau au chocolat gâteau d\'avoine tiramisu prune sucre. Donut tarte sucrée gâteau à l\'avoine dragée gouttes de fruits gâteau au citron en barbe à papa.'
  },
  pt: {
    "All_files_and_folders": "cvvvfgfgfg",
    Dashboard: 'painel de controle',
    eCommerce: 'comércio eletrônico',
    Apps: 'APPS',
    Todo: 'Façam',
    Chat: 'Bate-papo',
    Email: 'O email',
    Calendar: 'Calendário',
    FullCalendar: 'Calendário Completo',
    SimpleCalendar: 'Calendário Simples',
    Shop: 'fazer compras',
    ItemDetails: 'Detalhes do item',
    Cart: 'Carrinho',
    WishList: 'Lista de Desejos',
    Checkout: 'Confira',
    UI: 'UI',
    DataList: 'Lista de dados',
    ListView: 'Exibição de lista',
    ThumbView: 'Thumb View',
    Grid: 'Grade',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Cores',
    Card: 'Cartão',
    Basic: 'Basic',
    Statistics: 'Estatisticas',
    Analytics: 'Analytics',
    CardActions: 'Ações do Cartão',
    CardColors: 'Cores do cartão',
    Table: 'Mesa',
    agGridTable: 'Tabela AgGrid',
    Components: 'Componentes',
    Alert: 'Alerta',
    Avatar: 'Avatar',
    Badge: 'Crachá',
    Breadcrumb: 'Breadcrumb',
    Button: 'Botão',
    ButtonGroup: 'Grupo de botões',
    Chip: 'Lasca',
    Collapse: 'Colapso',
    Dialogs: 'Diálogos',
    Divider: 'Divisor',
    DropDown: 'Suspenso',
    List: 'Lista',
    Loading: 'Carregando',
    Navbar: 'Navbar',
    Notifications: 'Notificações',
    Pagination: 'Paginação',
    Popup: 'Aparecer',
    Progress: 'Progresso',
    Sidebar: 'Barra Lateral',
    Slider: 'Controle Deslizante',
    Tabs: 'Guias',
    Tooltip: 'dica de ferramenta',
    Upload: 'Envio',
    FormsAndTable: 'Formulários e tabela',
    FormElements: 'Elementos do formulário',
    Select: 'Selecione',
    Switch: 'Interruptor',
    Checkbox: 'Caixa de seleção',
    Radio: 'Rádio',
    Input: 'Entrada',
    NumberInput: 'Entrada numérica',
    Textarea: 'Textarea',
    FormLayouts: 'Layouts de formulário',
    FormWizard: 'Assistente de Formulário',
    FormValidation: 'Validação de Formulário',
    FormInputGroup: 'Grupo de entrada de formulário',
    Pages: 'PÁGINAS',
    Authentication: 'Autenticação',
    Login: 'Entrar',
    Register: 'Registo',
    ForgotPassword: 'Esqueceu A Senha',
    ResetPassword: 'Redefinir Senha',
    LockScreen: 'Tela de bloqueio',
    Miscellaneous: 'Diversos',
    ComingSoon: 'Em breve',
    Error: 'Erro',
    404: '404',
    500: '500',
    NotAuthorized: 'Não autorizado',
    Maintenance: 'Manutenção',
    Profile: 'Perfil',
    User: 'Do utilizador',
    View: 'Visão',
    Edit: 'Editar',
    UserSettings: 'Configurações do Usuário',
    Invoice: 'Fatura',
    FAQ: 'Perguntas frequentes',
    Search: 'Procurar',
    KnowledgeBase: 'Base de Conhecimento',
    ChartsAndMaps: 'Gráficos E Mapas',
    Charts: 'Gráficos',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Mapa',
    Extensions: 'Extensão',
    QuillEditor: 'Quill-Editor',
    DragAndDrop: 'Arraste e solte',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Seletor de data e hora',
    AccessControl: 'Controle de acesso',
    I18n: 'I18n',
    Carousel: 'Carrossel',
    Clipboard: 'Prancheta',
    ContextMenu: 'Menu contextual',
    StarRatings: 'Classificações por estrelas',
    Autocomplete: 'autocompletar',
    Tree: 'Árvore',
    // "Import/Export": 'Importar/Exportar',
    Import: 'Importar',
    Export: 'Exportar',
    ExportSelected: 'Exportar Selecionado',
    Others: 'Outras',
    MenuLevels: 'Níveis de Menu',
    MenuLevel2p1: 'Nível de menu 2.1',
    MenuLevel2p2: 'Nível de menu 2.2',
    MenuLevel3p1: 'Nível de menu 3.1',
    MenuLevel3p2: 'Nível de menu 3.2',
    DisabledMenu: 'Menu desativado',
    Support: 'Apoio, suporte',
    Documentation: 'Documentação',
    RaiseSupport: 'Levantar Suporte',
    demoTitle: 'Título do cartão',
    demoText: 'O sésamo do bolo agarra dinamarquês do pão-de-espécie do queque eu amo o pão-de-espécie. Torta de torta de maçã jujuba chupa chups muffin halvah pirulito. Ameixa do açúcar do maçapão do tiramisu do bolo da aveia do bolo de chocolate. Bolo de aveia de torta doce rosquinha dragée fruitcake algodão doce gotas de limão.'
  },
  fa: {
    "All_files_and_folders": "تمام پوشه ها",
    "Dashboard": "داشبورد",
    "Task Report": "گزارش کارها",
    "Incomplete": "تکمیل نشده",
    "Today": "امروز",
    "Overdue": "تاریخ گذشته",
    "Upcoming Week": "هفته پیش رو",
    "Generate Task": "وضعیت کارها",
    "Pending": "شروع نشده",
    "Progress": "درحال انجام",
    "Review": "بازبینی",
    "Completed": "تکمیل شده",
    "Recent Activity": "فعالیت های اخیر",
    "Activity": "فعالیت",
    "Duration": "زمان صرف شده",
    "Time": "زمان",
    "Invoices": "صورتحساب ها",
    "Unpaid": "پرداخت نشده",
    "Approved": "تایید شده",
    "Draft": "پیش نویس",
    "No Task Or Event": "کار یا رویداد جدیدی وجود ندارد",
    "Show bills": "نمایش صورتحساب ها",
    "Calendar": "تقویم",
    "Add event": "ایجاد رویداد",
    "Month": "ماه",
    "week": "هفته",
    "Year": "سال",
    "New Event": "رویداد جدید",
    "Title": "عنوان",
    "Start date": "تاریخ شروع",
    "Start time": "زمان شروع",
    "End date": "تاریخ پایان",
    "End time": "زمان پایان",
    "All day": "هرروز",
    "Repeat": "تکرار",
    "Location": "محل",
    "Attendees": "حاضرین",
    "Find a user": "یک کاربر انتخاب کنید",
    "Add this event to the Firm calendar": "این رویداد به تقویم شرکت افزوده شود",
    "Matter": "پرونده",
    "Label": "برچسب رنگی",
    "Tags": "تگ ها",
    "Enter your tags": "تگ های خود را وارد کنید",
    "Reminder": "یادآوری",
    "Description": "توضیح",
    "Save event": "ذخیره رویداد",
    "Cancel": "لغو",
    "Repeat this event": "تکرار رویداد",
    "Daily": "روزانه",
    "Weekly": "هفتگی",
    "Monthly": "ماهانه",
    "Yearly": "سالانه",
    "Every": "هر",
    "Day(s)": "روز",
    "Mo": "دوشنبه",
    "Tu": "سه شنبه",
    "We": "چهارشنبه",
    "Th": "پنج شنبه",
    "Fr": "جمعه",
    "Sa": "شنبه",
    "Su": "یکشنبه",
    "End": "پایان",
    "Never": "هرگز",
    "until the end of the year": "تا پایان سال",
    "After": "پس از",
    "occurrence(s)": "وقوع",
    "On": "در",
    "Summery": "خلاصه",
    "Remind me": "یادآوری کن",
    "Target date": "تاریخ مدنظر",
    "Notification type": "نوع نوتیفیکیشن",
    "Web and App": "وب و اپلیکیشن",
    "Email": "ایمیل",
    "Both": "هردو",
    "Select Notification Type": "نوع نوتیفیکیشن را انتخاب کنید",
    "Urgent": "اضطراری",
    "High": "ضروری",
    "Normal": "مهم",
    "Low": "کم اهمیت",
    "Task": "کار",
    "In progress": "درحال انجام",
    "In review": "در بازبینی",
    "List": "لیست",
    "Kanban": "کانبان",
    "Search task": "جستجوی کار",
    "Search": "جستجو",
    "ِDue date": "تارخ انجام",
    "Status": "وضعیت",
    "priority": "الویت",
    "Assigned": "واگذار شده به",
    "Recorded Time": "زمان ثبت شده",
    "Add Time": "ثبت زمان",
    "Edit": "ویرایش",
    "Delete": "حذف",
    "Action": "عملیات",
    "Actions": "عملیات ها",
    "No Due Date": "بدون تاریخ",
    "Upcoming": "پیش رو",
    "Filter And Export": "فیلترها و خروجی ها",
    "New": "جدید",
    "Task types": "انواع کار",
    "New Task": "کار جدید",
    "Task Type": "نوع کار",
    "Back to Tasks": "بازگشت به کارها",
    "Search task type": "جستجوی نوع کار",
    "records found": "نتیجه یافت شد",
    "Table Columns": "ستون های جدول",
    "New task": "کار جدید",
    "Details": "جزییات",
    "Task Name": "عنوان کار",
    "Enter Task Name": "عنوان کار را وارد کنید",
    "Enter Task description": "توضیح کار را وارد کنید",
    "Assignee": "مسئول",
    "Task status": "وضعیت کار",
    "Time estimate": "زمان پیش بینی شده",
    "Select date": "انتخاب تاریخ",
    "Save task": "ذخیره کار",
    "Profile": "پروفایل",
    "Contacts": "موکل ها",
    "All": "همه",
    "Search contacts": "جستجوی موکل ها",
    "Person": "اشخاص",
    "Company": "شرکت ها",
    "Which Type of Contact do you want to create?": "نوع موکل شما چیست؟",
    "Contact Information": "اطلاعات موکل",
    "ّFirstName": "نام",
    "LastName": "نام خانوادگی",
    "MiddleName": "نام میانی*********",
    "Prefix": "پیش نویش",
    "Birth Date": "تاریخ تولد",
    "Website": "وبسایت",
    "Address": "آدرس",
    "City": "شهر",
    "State": "استان",
    "Country": "کشور",
    "Postcode": "کد پستی",
    "ِDiscard": "لغو",
    "Add Address": "افزودن آدرس",
    "Unsaved changes": "تغییرات ذخیره شود؟",
    "Add Email": "افزودن ایمیل",
    "Add Website": "افزودن وبسایت",
    "Add PhoneNumber": "افزودن شماره تلفن",
    "Profile Photo": "تصویر پروفایل",
    "Upload": "بارگذاری",
    "Practice Area": "موضوع پرونده",
    "Group": "گروه",
    "Reference Code": "کد پرونده",
    "Responsible": "وکیل مسئول",
    "Originating": "وکیل ارجادهنده",
    "Origination": "وکیل ارجادهنده",
    "Add Note": "افزودن یادداشت",
    "New Matter": "پرونده جدید",
    "Opened date": "تاریخ شروع",
    "Closed date": "تاریخ خاتمه",
    "Limitation date": "تاریخ محدودیت",
    "Responsible Lawyer": "وکیل مسئول",
    "Originating Lawyer": "وکیل ارجادهنده",
    "Related contacts": "موکلین مرتبط",
    "Add related contacts": "افزودن موکلین مرتبط",
    "Associating a contact will allow you to easily locate their information from the matter dashboard. These contacts will also appear in future conflict checks.": "موکلین مرتبط به شما اجازه می دهد که در داشبرد پرونده آن ها را مشاهده و بررسی کنید.",
    "Billing preferences": "پیش فرض فاکتور",
    "Relationship": "ارتباط",
    "One or more billable matters can be used to create an invoice for a client.": "یک یا چند پرونده در صورتی که قابل فاکتور زدن باشند می توانند برای ساخت فاکتور استفاده شوند",
    "Matter is billable": "ئرونده قابل فاکتور زدن است",
    "Add a custom rate": "افزودن نرخ مشخص",
    "Hourly": "ساعتی",
    "Fixed Fee": "نرخ ثابت",
    "Matter budget": "بودجه پرونده",
    "Matter has a budget": "پرونده بودجه دارد",
    "budget": "بودجه",
    "Notify": "خبر کن",
    "Notification recipients": "دریافت کنندگان نوتیفیکیشن",
    "Limit": "محدودیت",
    "Required fields": "فیلدهای اجباری",
    "Recorded Time (hour)": "زمان ثبت شده (ساعت)",
    "Author": "نویسنده",
    "Note Information": "اطلاعات یادداشت",
    "Recorded time": "زمان ثبت شده",
    "Add a time entry to this note": "زمان برای یادداشت اضافه کنید",
    "Select firm users to receive notifications about this note": "کاربراتی که برای این یادداشت باید نوتیفیکیشن دریافت کنند را انتخاب کنید",
    "From date": "از تاریخ",
    "To date": "به تاریخ",
    "Non billable": "غیرقابل  پرداخت",
    "Billable": "قابل پرداخت",
    "Expense": "هزینه",
    "Expense Categories": "دسته بندی هزینه ها",
    "Time Categories": "دسته بندی زمان ها",
    "New time entry": "ثبت زمان جدید",
    "Headline": "موضوع",
    "Rate": "قیمت",
    "Default rate": "قیمت پیش فرض",
    "Save Entry": "ذخیره",
    "Disbursement/Recoveries": "هزینه های نرتبط با پرونده",
    "Operational Expense": "هزینه جاری",
    "Quantity": "مقدار",
    "Total amount": "مبلغ کل",
    "Vendor": "ارائه دهنده",
    "Reference": "کد پی گیری یا فاکتور",
    "Billing Method": "روش محاسبه",
    "User default rate": "پیش فرض کاربر",
    "Custom rate": "نرخ خاص",
    "Flat rate": "نرخ ثابت",
    "Save Category": "ذخیره دسته",
    "New Time Category": "دسته بندی جدید زمان",
    "New Expense Category": "دسته بندی جدید هزینه",
    "Used invoices": "فاکتور شده",
    "Activities": "فعالیت ها",
    // Documents##############################################################
    "File Upload": "بارگذاری فایل",
    "Folder Upload": "بارگذاری پوشه",
    "New Folder": "پوشه جدید",
    "All files and folders": "تمام فایل ها و پوشه ها",
    "Document Size": "حجم سند",
    "Upload Date": "تاریخ بارگذاری",
    "Select File": "انتخاب فایل",
    "File": "فایل",
    "Select Folder": "انتخاب فولدر",
    "Start Upload": "شروع بارگذاری",
    "Folder name": "نام پوشه",
    "Download count": "تعداد دفعات دانلود",
    // Communications########################################################
    "Call": "تماس",
    "Seach Call": "جستجوی تماس ها",
    "Communications": "ارتباط ها",
    "Contents of call": "محتوای تماس",
    "Add a time entry to this phone log": "برای این تماس زمان ثبت کنید",
    "Save phone log": "ذخیره",
    "Select Contacts": "انتخاب موکل ها",
    "Call Log": "ثبت تماس",
    "Email Log": "ثبت نامه نگاری",
    "Summary of E-mail": "خلاصه نامه",
    "Add a time entry to this email log": "برای این نامه زمان ثبت کنید",
    "Select Users": "انتخاب کاربران",
    "Save email log": "ذخیره",
    // Account###################################################################
    "َAccount": "حساب",
    "َAccount name": "نام حساب",
    "َAccount type": "نوع حساب",
    "َDefault account": "حساب پیش فرض",
    "Ballance": "مانده حساب",
    "Currency": "واحد پولی",
    "َAccount number": "شماره حساب",
    "Sort code": "شماره مرتب سازی",
    "Account holder": "صاحب حساب",
    "Institution": "موسسه",
    "Branch": "شعبه",
    "Swift": "سوییفت",
    "Opening balance": "مبلغ افتتاح حساب",
    "This is the specific branch of the institution where the account is held": "این شعبه ای هست که حساب در آن باز شده است.",
    "This is a code for facilitating wire transfers via Society for Worldwide Interbank Financial Telecommunication.": "این یک کد برای تسهیل عملیات بانکی بین المللی است.",
    "Once the bank account is created, you can use transactions to make further changes to your balance.": "به محض ایجاد حساب شما می توانید تراکنش انجام دهید و در حساب خود ثبت کنید. ",
    "A default account will show up first on the Transactions tab of Matters and Clients.": "حساب پیش فرض بصورت خودکار در ابتدای لیست حساب های بانکی در بخش های مختلف قرار می گیرد.",
    "Create New Bank Account": "ساخت حساب بانکی جدید",
    // billing###################################################
    "Billing": "فاکتور",
    "All Invoices": "همه فاکتورها",
    "Status Bill": "وضعیت فاکتور",
    "Search Bill": "جستجوی فاکتورها",
    "Receipt": "رسید",
    "Receipt no": "شماره رسید",
    "Payment Type": "نوع پرداخت",
    "Remark": "توضیحات",
    "Amount": "مبلغ",
    "Bank in Date": "تاریخ ثبت بانک",
    "Payment For": "پرداخت برای",
    "Receive From": "دریافت شده از",
    "New Trust Fund Request": "درخواست وجه از مشتری",
    "New Official Receipt": "درخواست وجه جدید از موکل",
    "Select billable clients to generate new bills": "موکل را برای صدور فاکتور انتخاب کنید",
    "Billable Clients selected.": "موکل برای صدور فاکتور",
    "Unbilled Hours": "ساعت های فاکتور نشده",
    "Unbilled Expense": "هزینه های فاکتور نشده",
    "Amount Due": "مبلغ سررسید",
    "Specific Time Entry": "زمان های خاص",
    "Specific Expense Entry": "هزینه های خاص",
    "Generate Invoices": "ساخت فاکتور",
    "Issue date": "تاریخ سررسید",
    "Detail Level": "سطح جزییات",
    "Apply tax": "اعمال مالیات",
    "Skip the bill approval process": "پرشاز فرآیند تایید فاکتور",
    "Item No": "ردیف",
    "Qty/Hr": "مقدار/ساعت",
    "Unit Price": "قیمت واحد",
    "Record Payment": "پرداخت",
    "Total": "مبلغ کل",
    "Discount": "تخفیف",
    "Balance Type": "مانده حساب براساس",
    "Outstanding Balance": "مانده حساب",
    "Amount Paid": "مبلغ پرداخت شده",
    "Type": "نوع",
    "Invoice date": "تاریخ فاکتور",
    "Payment Due": "تاریخ پرداخت",
    // reports#############################################
    "Accounts Receivable": "حساب های دریافتنی",
    "Report of outstanding receivables" : "گزارش مانده حساب های دریافتنی",
    "Accounts Receivable Aging": "جساب های دریافتنی ساالانه",
    "Report of accounts receivable broken up by periods of time." : "گزارش مانده حساب های دریافتنی براساس بازه زمانی",
    "Billing History": "گزارش فاکتورها",
    "Report of both current and past bills." : "گزارش فاکتور ها گذشته و حال",
    "Matter Balance Summary": "خلاصه مانده حساب پرونده ها",
    "Summary of all open matters with outstanding receivables and work in progress." : "خلاصه ای از تمام مانده پرونده های باز و کارهای در جریان",
    "Invoice Payments Report": "گزارش پرداخت فاکتورها",
    "A general ledger of payments made on invoices. Includes corresponding credits on each item of service and expense." : "دفترکل پرداخت های انجام شده روی فاکتورها شامل اعتبارهای و خدمات وهزینه ها",
    "Client Activity": "گزارش فعالیت موکل ها",
    "Summary of billable client activity." : "گزارش خلاصه از فعالیت های قابل پرداخت موکلین",
    "Client Ledger": "دفترکل موکلین",
    "Detailed report of all Client balances." : "گزارش با جزییات مانده حساب های موکلین",
    "Client Account Ledger": "دفترکل حساب مشتری",
    "Detailed report of Client and Matter client account balances." : "گزارش جزیی از موجودی حساب موکلین و پرونده ها",
    "Client Account Management": "مدیریت حساب موکل ها",
    "Summary of unbilled activities and available client account balances." : "گزارش خلاصه از فعالیت های فاکتور نشده و مانده حساب موکلین",
    "Client Account Listing": "فهرست حساب مشتریان",
    "Summary of client account balances." : "خلاصه گزارش مانده حساب موکلین",
    "Work In Progress": "فعالیت های انجام شده و کارهای در جریان",
    "Ongoing/unbilled Client activity." : "فعالیت های درجریان و فاکتور نشده موکلین",
    "Bank Account Activity": "فعالیت های حساب بانکی",
    "Report of financial transactions." : "گزارش تراکنش های مالی",
    "Matters by Responsible Lawyer": "پرونده ها براساس وکیل مسئول",
    "Listing of matters, status, and accounts receivable." : "",
    "Revenue Report": "گزارش درآمد",
    "Listing of matters grouped by responsible Lawyer." : "لیست کردن پرونده ها براساس وکیل مسئول",
    "Tax Report": "گزارش مالیات ها",
    "Summary of Tax." : "خلاصه مالیات ها",
    "Summary of unbilled, billed, and collected amounts." : "خلاصه از فاکتورنشده، فاکتور شده و مبالغ دریافتی",
    "User progress against their assigned tasks." : "گزارش پیشرفت کارمندان براساس کارهای محوله به آن ها",
    "Listing of matters with client contact information." : "فهرست پرونده ها با اطلاعات تماس موکل ها",
    "Summary of tasks grouped by user." : "خلاصه از کارها براساس کاربران ",
    "Task Progress by User": "پیشرفت کارهای محوله براساس کاربر",
    "Task Productivity by User": "بهره وری کارها براساس کاربر",
    "Select Responsible Lawyer": "انتخاب وکیل مسئول",
    "Select Client/Matter": "انتخاب موکل/پرونده",
    "Group Results By": "گروه بندی براساس",
    "Select Date Range": "انتخاب بازه تاریخی",
    "All Lawyers": "همه وکیل ها",
    " All Clients": "همه موکلین",
    "Specific Client": "موکل خاص",
    "Specific Matter": "پرونده خاص",
    "Display Bank Account Summary": "نمایش خلاصه حساب بانک",
    "Include Opening Balance": "شامل مبلغ افتتاح حساب",
    "Display Matter to Matter Transfer Transactions": "نمایش جابجایی تراکنشی پرونده به پرونده",
    "Show clients with zero balance": "نمایش موکل ها با مانده حساب صفر",
    "Generate Report": "ایجاد گزارش",
    "Break down level detail": "مشخص کردن سطح جزییات",
    "Trust accounts": "تکمیل",
    "Select Originating Lawyer": "انتخاب وکیل ارجادهنده پرونده",
    "Include balances not associated with a client": "سامل حساب های اختصاص نشده به موکلین",
    "Matter Status": "وضعیت پرونده",
    "Task Progress": "پیشرفت کارها",
    "Task Productivity": "بهره وری کارها",

  }
}


// {{ $t('Dashboard') }}
// {{ $t('Dashboard') }}
